module.exports = {
	salesforceSansLightWoff2: '/_slds/fonts/v2.3.0/SalesforceSans-Light.woff2',
	salesforceSansBoldWoff: '/_slds/fonts/v2.3.0/SalesforceSans-Bold.woff',
	salesforceSansRegularWoff: '/_slds/fonts/v2.3.0/SalesforceSans-Regular.woff',
	salesforceSansRegularWoff2:
		'/_slds/fonts/v2.3.0/SalesforceSans-Regular.woff2',
	salesforceSansBoldWoff2: '/_slds/fonts/v2.3.0/SalesforceSans-Bold.woff2',
	salesforceSansLightWoff: '/_slds/fonts/v2.3.0/SalesforceSans-Light.woff',
	salesforceSansItalicWoff2: '/_slds/fonts/v2.3.0/SalesforceSans-Italic.woff2',
	salesforceSansBoldItalicWoff2:
		'/_slds/fonts/v2.3.0/SalesforceSans-BoldItalic.woff2',
	salesforceSansBoldItalicWoff:
		'/_slds/fonts/v2.3.0/SalesforceSans-BoldItalic.woff',
	salesforceSansItalicWoff: '/_slds/fonts/v2.3.0/SalesforceSans-Italic.woff',
};
